// Web mock for react-native-system-navigation-bar (Android-only module)
export default {
  setNavigationColor: () => Promise.resolve(),
  navigationHide: () => Promise.resolve(),
  navigationShow: () => Promise.resolve(),
  setNavigationBarContrastEnforced: () => Promise.resolve(),
  setBarMode: () => Promise.resolve(),
  getBarMode: () => Promise.resolve('light'),
  setNavigationBarDividerColor: () => Promise.resolve(),
  fullScreen: () => Promise.resolve(),
  leanBack: () => Promise.resolve(),
  immersive: () => Promise.resolve(),
  stickyImmersive: () => Promise.resolve(),
  lowProfile: () => Promise.resolve(),
};
